//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAE.js";
import "../no/NXObject.js";
let d=[[],[[[],"Validate",{},0,0],[[],"WriteSolverInputFile",{},0,0],[[],"Solve",{},0,0],[["name"],"Rename",{},1,0],[[],"CreateLoadRecipeFromResults",{R_:{loadRecipe:"CAE.SimLoadRecipe"}},0,0],[[],"CreateSourceNodesGroup",{R_:{group:"CAE.CaeGroup"}},0,0],[[],"CreateTargetNodesGroup",{R_:{group:"CAE.CaeGroup"}},0,0]],[["Operations","CAE.ModelAndLoadPreProcessOperations",0]]];
SPLM.CAE.ModelAndLoadPreProcess = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAE.ModelAndLoadPreProcess";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;